import { IncomeConfirmationModalTexts } from '../IncomeConfirmationModal.texts';

import { pluralizeBanks } from './pluralizeBanks';

export const getEsiaButtonTitle = (organizationsCount: number) => {
  if (organizationsCount <= 0) {
    return IncomeConfirmationModalTexts.esiaButtonWithoutCount;
  }

  return `${IncomeConfirmationModalTexts.esiaButtonPrefix} ${organizationsCount} ${pluralizeBanks(organizationsCount)}`;
};
